import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BarChart3, X } from 'lucide-react';
import { usePerfil } from '../../context/PerfilContext';

/** Días del mes en que Inicio avisa de que el resumen del mes anterior está listo. */
const DIAS_AVISO = 7;

/**
 * I12: los primeros días de cada mes, en Inicio de Finanzas, un aviso para
 * ver el resumen del mes que acaba de terminar (solo con Plus). Al cerrarlo
 * no vuelve hasta el mes siguiente en este dispositivo.
 */
export const AvisoResumenMes: React.FC = () => {
  const { esPlus } = usePerfil();
  const hoy = new Date();
  const anterior = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
  const clave = `rzcentral.resumenVisto.${anterior.getFullYear()}-${anterior.getMonth() + 1}`;
  const [cerrado, setCerrado] = useState(() => {
    try { return localStorage.getItem(clave) === '1'; } catch { return false; }
  });

  if (!esPlus || cerrado || hoy.getDate() > DIAS_AVISO) return null;

  const cerrar = () => {
    try { localStorage.setItem(clave, '1'); } catch { /* sin almacenamiento: se cierra solo esta vez */ }
    setCerrado(true);
  };
  const mes = anterior.toLocaleDateString('es-ES', { month: 'long' });

  return (
    <div className="flex items-center gap-3 bg-blue-50 dark:bg-blue-900/25 border border-blue-200 dark:border-blue-800 rounded-xl px-4 py-3 mb-6">
      <BarChart3 className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0" />
      <Link to="/finanzas/informes?seccion=resumen" onClick={cerrar} className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-blue-800 dark:text-blue-200">Tu resumen de {mes} está listo</p>
        <p className="text-xs text-blue-700 dark:text-blue-300">Cuánto ahorraste y qué se disparó frente a lo habitual.</p>
      </Link>
      <button type="button" onClick={cerrar} aria-label="Cerrar" className="p-1 text-blue-500 hover:text-blue-700 dark:hover:text-blue-300">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
